import React, { createContext, useContext, useMemo, useState } from 'react'
import { tsLoginConfig, tsWhoAmI } from '../Typescript/API_Response'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { getColourPalette } from '../Functions/GetColourPalette'
import { useGetLoginConfig } from '../APIs/Hooks/UserHooks'
import { LocalAutoLoginAuth } from '../Functions/LocalAutoLoginAuth'
import { UseQueryResult } from 'react-query'
import { AxiosResponse } from 'axios'
import { usePyGet } from '../APIs/Hooks/PyAPIHooks'

interface UserContextType {
  whoAmI: tsWhoAmI | undefined
  setWhoAmI: any
  loginConfig: tsLoginConfig | undefined
  loadingConfig: boolean
  meQuery: UseQueryResult<any, AxiosResponse<any, any>>
}

export const UserContext = createContext<UserContextType>({} as UserContextType)

export const useUserContext = () => useContext(UserContext)

function UserConfig({ children }: { children: any }) {
  //set from RequiredAuth
  const [auth, setAuth] = useState<undefined | tsWhoAmI>(LocalAutoLoginAuth())
  const { data: loginConfig, isLoading } = useGetLoginConfig(auth)
  const meQuery = usePyGet(['/gia/me'], !!auth, auth)

  // Update the theme only if the mode changes
  const theme = useMemo(
    () => createTheme(getColourPalette(loginConfig)),
    [loginConfig],
  )

  return (
    <UserContext.Provider
      value={{
        whoAmI: auth,
        setWhoAmI: setAuth,
        loginConfig,
        loadingConfig: isLoading,
        meQuery,
      }}
    >
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </UserContext.Provider>
  )
}

export default UserConfig
